import { createAction, props } from '@ngrx/store';
import { ClientLocation, WorkDay , Store, PaymentResult} from '@core/models';
import { IResponseBadRequest } from '@core/interfaces';

export const STORE_FIND = createAction('[Store] Find');
export const STORE_FIND_BY_ID = createAction('[Store] Find By Id');

export const STORE_FIND_SUCCESS = createAction('[Store] Find Success', props<{ store: Store | null }>());

export const STORE_FAILED = createAction('[Store] Failed', props<{ error: IResponseBadRequest }>());
export const STORE_UPDATE_LOADING = createAction('[Store] Update Loading', props<{ loading: boolean }>());

export const STORE_RESET_STATE = createAction('[Store] Reset State');

export const STORE_CLOSED = createAction('[Store] Closed',props<{ message: string }>());

export const CHECK_BUSINESS_DAY = createAction('[Store] Check Business Day');
export const CHECK_BUSINESS_DAY_SUCCESS = createAction('[Store] Check Business Day Success',props<{ workDay: WorkDay | null }>());
export const CHECK_BUSINESS_DAY_FAILURE = createAction('[Store] Check Business Day Failure',props<{ error: IResponseBadRequest | PaymentResult | null | string }>());

export const STORE_FIND_LOCATION = createAction('[Store] Find Location');
export const STORE_FIND_LOCATION_SUCCESS = createAction('[Store] Find Location Success',props<{ location: ClientLocation }>());
export const STORE_FIND_LOCATION_FAILURE = createAction('[Store] Find Location Failure',props<{ error: IResponseBadRequest }>());


export const STORE_FIND_ALL = createAction('[Store] Find All', props<{ accountSlug: string | null }>());
export const STORE_FIND_ALL_SUCCESS = createAction('[Store] Find All Success', props<{ storeList: Store[] }>());

export const STORE_IS_MULTI_UPDATE = createAction('[Store] Is Multi Update', props<{ isMultiStore: boolean }>());
